import { Box } from '@mui/material';
import { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { YouCanComeBackNote } from '../../../../general/components/footers/you-can-come-back-note';
import { WizardPage } from '../../../../general/components/wizard-page';
import { RootState } from '../../../../store';
import { FinancialDocumentsUpload } from '../../components/financial-documents-upload';
import { FinancialStatementRequirements } from '../../components/financial-statement-requirements';
import { uploadFinancialDocuments } from '../../reducers/document-requirements.reducer';

const JULY = 6;

const financialStatementYears = (): string => {
  const now = new Date();
  const year = now.getFullYear();

  return now.getMonth() >= JULY ? `${year} year to date, ${year - 1}, and ${year - 2}` : `${year - 1} and ${year - 2}`;
};

const selector = ({
  documentRequirements: { requiredDocuments, loading: uploading, error: uploadError },
  nextStep: { loading: appLoading, error: appError },
}: RootState) => ({
  documentRequirement: requiredDocuments.at(0),
  submitting: uploading || appLoading,
  error: uploadError ?? appError,
});

const FinancialStatementsPage: FC = () => {
  const dispatch = useDispatch();
  const { documentRequirement, submitting, error } = useSelector(selector);

  const handleSubmit = useCallback(
    (files: File[]) => {
      if (documentRequirement) {
        dispatch(uploadFinancialDocuments({ document: documentRequirement, files }));
      }
    },
    [dispatch, documentRequirement],
  );

  return (
    <WizardPage
      title="Upload your financial statements"
      subtext={
        <>
          We use these statements to better understand your business and <br />
          determine a credit line that’s high enough to support your spending.
        </>
      }
      error={error}
      footer={<YouCanComeBackNote />}
    >
      <FinancialStatementRequirements years={financialStatementYears()} />
      <Box mt={3}>
        <FinancialDocumentsUpload
          submitting={submitting}
          progress={documentRequirement?.progress}
          progressComputable={documentRequirement?.progressComputable}
          disabled={!documentRequirement}
          onSubmit={handleSubmit}
        />
      </Box>
    </WizardPage>
  );
};

export { FinancialStatementsPage };
